import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import { categoryLabel } from './resourcesData';

const AuthorIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="#5B6472" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;

const authorName = (post) => (post.author?.name || '').replace(/,\s*$/, '');
const detailHref = (post) => ROUTES.BLOG_DETAILS.replace(':slug', post.slug);

const FeaturedCard = ({ post }) => (
    <div className="lp-res-featured">
        <span className="ribbon">Featured</span>
        <div className="img" style={{ backgroundImage: `url(${post.image})` }} />
        <div className="body">
            <div className="cats">{(post.category || []).slice(0, 2).map(categoryLabel).join(' · ')}</div>
            <h2>{post.title}</h2>
            <p>{post.excerpt}</p>
            <div className="author">
                <span className="avatar"><AuthorIcon /></span>
                <span>{authorName(post)} · {post.date}</span>
            </div>
            <Link to={detailHref(post)}>Read article →</Link>
        </div>
    </div>
);

const ArticleCard = ({ post }) => (
    <div className="lp-res-card">
        <div className="img" style={{ backgroundImage: `url(${post.image})` }} />
        <div className="body">
            <div className="cats">{(post.category || []).slice(0, 2).map(categoryLabel).join(' · ')}</div>
            <h3>{post.title}</h3>
            <p>{post.excerpt}</p>
            <div className="author">
                <span className="avatar"><AuthorIcon /></span>
                <span>{authorName(post)} · {post.date}</span>
            </div>
            <Link to={detailHref(post)}>Read article →</Link>
        </div>
    </div>
);

const ResourcesArticleGrid = ({ featured, posts, totalCount, visiblePosts, hasMore, onShowMore }) => (
    <>
        {featured && (
            <section className="lp-res-featured-sec">
                <div className="lp-container" style={{ maxWidth: 1200 }}>
                    <FeaturedCard post={featured} />
                </div>
            </section>
        )}

        <section className="lp-res-grid-sec">
            <div className="lp-container" style={{ maxWidth: 1200 }}>
                <div className="lp-res-grid-head">
                    <h2>All resources</h2>
                    <span className="count">{totalCount} article{totalCount === 1 ? '' : 's'}</span>
                </div>

                {totalCount === 0
                    ? <div className="lp-res-empty">No results.</div>
                    : (
                        <>
                            <div className="lp-res-grid">
                                {visiblePosts.map((post) => <ArticleCard post={post} key={post.slug} />)}
                            </div>
                            {hasMore && (
                                <div className="lp-res-showmore">
                                    <button onClick={onShowMore}>Show more articles</button>
                                </div>
                            )}
                        </>
                    )}
            </div>
        </section>
    </>
);

export default ResourcesArticleGrid;
